/// Port of mobile/lib/features/user/data/user_local_data.dart.

const anonymousHighScoreKey = 'anonymousHighScore';
const anonymousIdKey = 'anonymousId';
const analyticsSessionIdKey = 'analyticsSessionId';

export function readAnonymousHighScore(): number {
  try {
    const raw = localStorage.getItem(anonymousHighScoreKey);
    const parsed = raw === null ? 0 : Number.parseInt(raw, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
  } catch {
    return 0;
  }
}

export function writeAnonymousHighScore(score: number): void {
  try {
    localStorage.setItem(anonymousHighScoreKey, String(score));
  } catch {
    // Non-fatal: the guest score just will not survive a reload.
  }
}

export function clearAnonymousHighScore(): void {
  try {
    localStorage.removeItem(anonymousHighScoreKey);
  } catch {
    // Ignored for the same reason as above.
  }
}

function autoUsernamePromptDismissedKey(userId: string): string {
  return `autoUsernamePromptDismissed_${userId}`;
}

export function isAutoUsernamePromptDismissed(userId: string): boolean {
  try {
    return localStorage.getItem(autoUsernamePromptDismissedKey(userId)) === '1';
  } catch {
    return false;
  }
}

export function setAutoUsernamePromptDismissed(userId: string): void {
  try {
    localStorage.setItem(autoUsernamePromptDismissedKey(userId), '1');
  } catch {
    // Non-fatal.
  }
}

function newUuidV4(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function readOrCreateAnonymousId(): string {
  try {
    const existing = localStorage.getItem(anonymousIdKey);
    if (existing) return existing;
    const id = newUuidV4();
    localStorage.setItem(anonymousIdKey, id);
    return id;
  } catch {
    return newUuidV4();
  }
}

export function readOrCreateAnalyticsSessionId(): string {
  try {
    const existing = localStorage.getItem(analyticsSessionIdKey);
    if (existing) return existing;
    return rotateAnalyticsSessionId();
  } catch {
    return newUuidV4();
  }
}

export function rotateAnalyticsSessionId(): string {
  const id = newUuidV4();
  try {
    localStorage.setItem(analyticsSessionIdKey, id);
  } catch {
    // ignore
  }
  return id;
}
